import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import TableCellTypography from 'shared/components/widgets/tabel-cell-typography';
import { bytesToSize } from 'shared/helpers/bytes-to-size';
import { getClassification } from 'shared/helpers/external-delivery/get-classification';
import { getDepartment } from 'shared/helpers/external-delivery/get-department';
import TooltipWithTableCellTypography from '../../../shared/components/widgets/tooltip';

export const externalDeliveryFilesListColumns: GridColDef[] = [
  {
    field: 'shmSeq',
    headerName: 'No', // Number
    headerAlign: 'left',
    align: 'left',
    flex: 1,
    maxWidth: 80,
    minWidth: 80,
    sortable: false,
    renderCell: (params: GridRenderCellParams) => {
      return (
        <TableCellTypography>
          {params?.row?.id || params?.row?.id === 0 ? params?.row?.id : '--'}
        </TableCellTypography>
      );
    },
  },
  {
    field: 'shmLfsKind',
    headerName: '분류', // Classification
    headerAlign: 'left',
    align: 'left',
    flex: 1,
    maxWidth: 128,
    minWidth: 128,
    sortable: true,
    renderCell: (params: GridRenderCellParams) => {
      return (
        <TableCellTypography>
          {getClassification(params.value) ?? '--'}
        </TableCellTypography>
      );
    },
  },
  {
    field: 'shmDeptCd',
    headerName: '부서', // Department
    headerAlign: 'left',
    align: 'left',
    flex: 2,
    maxWidth: 160,
    minWidth: 160,
    sortable: true,
    renderCell: (params: GridRenderCellParams) => {
      return (
        <TableCellTypography>
          {getDepartment(params.value) ?? '--'}
        </TableCellTypography>
      );
    },
  },
  {
    field: 'shmSubject',
    headerName: '업로드 제목', // Upload Title
    headerAlign: 'left',
    align: 'left',
    flex: 1,
    maxWidth: 260,
    minWidth: 260,
    sortable: true,
    renderCell: (params: GridRenderCellParams) => {
      return <TooltipWithTableCellTypography value={params.value} />;
    },
  },

  {
    field: 'fileCount',
    headerName: '첨부파일 유무', // Presence of Attached Files
    headerAlign: 'left',
    align: 'left',
    flex: 1,
    maxWidth: 180,
    minWidth: 180,
    sortable: false,
    renderCell: (params: GridRenderCellParams) => {
      return (
        <TableCellTypography
          style={{
            color: params.value > 0 ? 'var(--gray-800)' : 'var(--neutral-800)',
          }}
        >
          {params.value > 0 ? '○' : '☓'}
        </TableCellTypography>
      );
    },
  },

  {
    field: 'shmfOriginName',
    headerName: '파일명', // File Name
    headerAlign: 'left',
    align: 'left',
    flex: 1,
    maxWidth: 240,
    minWidth: 240,
    sortable: true,
    renderCell: (params: GridRenderCellParams) => {
      return <TooltipWithTableCellTypography value={params.value} />;
    },
  },

  {
    field: 'shmfSize',
    headerName: '파일크기', // File Size
    headerAlign: 'left',
    align: 'left',
    flex: 1,
    sortable: false,
    maxWidth: 90,
    minWidth: 90,
    renderCell: (params: GridRenderCellParams) => {
      return (
        <TableCellTypography>
          {bytesToSize(params.value) ?? '--'}
        </TableCellTypography>
      );
    },
  },
  {
    field: 'regDt',
    headerName: '등록일시', // Registration Date and Time
    headerAlign: 'left',
    align: 'left',
    flex: 1,
    sortable: true,
    maxWidth: 282,
    minWidth: 282,
    renderCell: (params: GridRenderCellParams) => {
      return <TableCellTypography>{params.value ?? '--'}</TableCellTypography>;
    },
  },
];
